import React, {useCallback, useEffect, useState} from 'react';
import {HeroSm, MyInput, NavBar, Spinner} from '../../components';
import { Footer } from '../../layouts';
import $ from 'jquery';
import {passwordFormatReg, Slang} from '../../helpers';
import {Link, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {authActions} from "../../store";
import axios from "axios";
import {fetchWrapper} from "../../helpers/fetch-wrapper";
import config from "../../config";
import {GoogleReCaptcha} from "react-google-recaptcha-v3";
import {toast} from "react-toastify";




const UpdatePassword = () => {
    const [loadPage, setLoadPage] = useState(true);

    useEffect(() => {

        let tim2 = setTimeout(() => {
            setLoadPage(false);
        }, 100);


        return () => {
            clearInterval(tim2);
        };
    }, []);


    return <>

        {
            loadPage
                ? <>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        width: '100%',
                        position: 'fixed',
                        left: 0,
                        top: 0,
                    }}>
                        <Spinner color={"success"} size={3} />

                    </div>

                </>
                : <Main />
        }

        {/*<Helmet>*/}
        {/*  /!* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet" /> *!/*/}
        {/*  <title>Register your Business</title>*/}
        {/*  <link rel="stylesheet" href="./assets/css/bootstrap/icons/bootstrap-icons.css" />*/}
        {/*  <link rel="stylesheet" href="./assets/css/hs/mega-menu/mega-menu.min.css" />*/}
        {/*  <link rel="stylesheet" href="./assets/css/_theme.css" />*/}

        {/*  <script defer asyn src="./assets/js/bootstrap/bootstrap.bundle.min.js"></script>*/}
        {/*  <script defer asyn src="./assets/js/hs/go-to/goto.min.js"></script>*/}
        {/*  <script defer asyn src="./assets/js/prism/prism.js"></script>*/}
        {/*  <script defer asyn src="./assets/js/hs/show-animation/show-animation.min.js"></script>*/}
        {/*  <script defer asyn src="./assets/js/hs/mega-menu/mega-menu.min.js"></script>*/}
        {/*  <script defer asyn src="./assets/js/hs/header/header.min.js"></script>*/}
        {/*  <script defer asyn src="./assets/js/fslightbox/index.js"></script>*/}
        {/*  <script defer asyn src="./assets/js/theme.min.js"></script>*/}

        {/*</Helmet>*/}
    </>
}

export default UpdatePassword;


const Main = () => {
    const passwordValLang = Slang("Validation.password");
    const [passwordError, setPasswordError] = useState(null);
    const [formValid, setFormValid] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user)

    const [data, setData] = useState({
        ip: "",
        confirm_password: "",
        password: "",
    });
    const lang = Slang('resetPassword');
    const langRegister = Slang('Register');
    const pInfoLang = Slang("Register.PersonnalsInfo");

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "password") {
            validatePassword(value);
        }
        if (name === "confirm_password") {
            validateConfirmPassword(data.password, value);
        }
        setData({ ...data, [name]: value });
    };

    const handleSubmit = e => {
        e.preventDefault();
        if (!formValid) {
            toast.info("Form contains errors");
            return;
        }
        setSubmitted(true)
        // const ip = sessionStorage.getItem('ip')
        const body = {password: data.password, password_confirmation: data.confirm_password, email: user.email}
        fetchWrapper.post(`${config.apiUrl}/user/change/pass`, body)
            .then(response => {
                setSubmitted(false)
                navigate('/login')
            })
            .catch(e => {
                setSubmitted(false)
            })
    };


    const storeUserInfo = (data) => {
        dispatch(authActions.setToken(data.token))
        dispatch(authActions.setUser(data.user))
        dispatch(authActions.setIsAuth(true))
    }

    const getIpAddress = () => {
        axios.get('https://api.ipify.org/?format=json')
            .then(response => {
                sessionStorage.setItem('ip', response.data.ip)
                setData({ ...data, ip: response.data.ip });
            })

    }

    const validatePassword = (text) => {
        const result = passwordFormatReg(text);

        if (!result.size) {
            setPasswordError(passwordValLang("p1"));
            setFormValid(false);
        } else if (!result.lower) {
            setPasswordError(passwordValLang("p2"));
            setFormValid(false);
        } else if (!result.upper) {
            setPasswordError(passwordValLang("p3"));
            setFormValid(false);
        } else if (!result.number) {
            setPasswordError(passwordValLang("p4"));
            setFormValid(false);
        } else if (!result.special) {
            setPasswordError(passwordValLang("p5"));
            setFormValid(false);
        } else {
            setPasswordError(null);
            setFormValid(true);
        }
    };

    const validateConfirmPassword = (password, confirm) => {
        if (password !== confirm) {
            setPasswordMatchError(passwordValLang("p6"));
            setFormValid(false);
        } else {
            setPasswordMatchError(null);
            setFormValid(true);
        }
    };

    useEffect(() => {
        const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;

        $('body').append(`<script className="homescript">${script}</script>`)

        getIpAddress()

        return () => {
            $('.homescript').remove();
        };
    }, []);
    return <>
        {/*{window.location.pathname === "add-business" ? <NavBar /> : null}*/}
        <NavBar />
        <HeroSm title={lang('t3')} />
        <main id="content" role="main">
            <div className="container content-space-3 content-space-t-lg-1 content-space-b-lg-3">
                <div className="flex-grow-1 mx-auto" style={{maxWidth: "28rem"}}>
                    <div className="text-center mb-5 mb-md-7">
                        <h1 className="h2"><img src="./assets/img/logos/155x47/initial/PNG/init_gradient.png" alt="logo"
                                                style={{height: '7vh'}}/></h1>
                    </div>

                    <form onSubmit={handleSubmit} className="js-validate needs-validation">
                        <div className="mb-3">
                            <MyInput
                                required={true}
                                handleChange={handleChange}
                                id="password"
                                name="password"
                                placeholder={pInfoLang("t6")}
                                label={pInfoLang("t6")}
                                type="password"
                                error={passwordError}
                            />
                        </div>
                        <div className="mb-3">
                            <MyInput
                                required={true}
                                handleChange={handleChange}
                                id="confirm-password"
                                name="confirm_password"
                                placeholder={pInfoLang("t7")}
                                label={pInfoLang("t7")}
                                type="password"
                                error={passwordMatchError}
                            />
                        </div>
                        {/*<GoogleReCaptcha*/}
                        {/*    className="google-recaptcha-custom-class"*/}
                        {/*    onVerify={onVerify}*/}
                        {/*    refreshReCaptcha={refreshReCaptcha}*/}
                        {/*/>*/}
                        <br/>
                        <div className="d-grid mb-3 col-md-12 col-sm-12">
                            <button disabled={submitted} type="submit"
                                    className="btn btn-primary btn-lg">
                                {submitted ? <Spinner color="light"/> : pInfoLang('t8')}
                            </button>
                        </div>
                    </form>
                    {/*<div className="text-center">*/}
                    {/*    <p>{langRegister("t9")} <Link className="link" to="/register">{langRegister("10")}</Link></p>*/}
                    {/*    <p><Link className="link" to="/forgot-password">{langRegister("11")}</Link></p>*/}
                    {/*</div>*/}
                </div>
            </div>
        </main>
        <Footer/>
    </>;
};
